import { useTranslation } from 'react-i18next';

const ErrorPage = () => {
    const { t } = useTranslation(['common']);

    return (
        <div>
            <h1>{t('common:errors:500:title')}</h1>
            <p>{t('common:errors:500:description')}</p>
        </div>
    );
};

export default ErrorPage;
